/*LIST*/
Vue.component('clientlist', {
    template:'#clientlist-template',

    data:function(){
        return{
            list: [],
            searchString:'',
            modal:'',
        };
    },
    created:function(){

        activeInstance = this;

        showLoadingOverlay();
        Vue.http.get(baseURL+'/api/client/list/all',function(response){
            $('body').LoadingOverlay("hide");
            activeInstance.list=response;

            setTimeout(function(){
                var $table = $('.fixed_header_table');
                $table.floatThead({
                    top:70
                });
            },200);

        }).bind(this);
        activeInstance.modal = $('#modal_create_client').html();
    },

    methods:{
        create:function(){

            /*
            bootbox.prompt('Az új ügyfél neve:',function(value){
                Vue.http.post(baseURL+'/admin/client/create',{name:value}).then(function(response){
                    activeInstance.list.push(response.data);
                });
            });
            */

            bootbox.dialog({
                    title: "Új ügyfél hozzáadása",
                    message: this.modal,
                    buttons: {
                        success: {
                            label: "Save",
                            className: "btn-success",
                            callback: function () {

                                $('.field').removeClass('error');
                                var validation = true;

                                //VALIDATE EVERYTHING!!
                                var name							=  $('.bootbox-body').find('#field_name').val();
                                var email							=  $('.bootbox-body').find('#field_email').val();
                                var invoice_address					=  $('.bootbox-body').find('#field_invoice_address').val();
                                var post_address					=  $('.bootbox-body').find('#field_post_address').val();
                                var bank_account					=  $('.bootbox-body').find('#field_bank_account').val();
                                var vat_number					    =  $('.bootbox-body').find('#field_vat_number').val();
                                var brand						    =  $('.bootbox-body').find('#field_brand').val();
                                var sub_brand						=  $('.bootbox-body').find('#field_sub_brand').val();
//							var short_code						=  $('.bootbox-body').find('#field_short_code').val();

                                if(name.length < 2){
                                    validation = false;
                                    errorNotification('A cégnév túl rövid!');
                                    $('.bootbox-body').find('#field_name').addClass('error');
                                }

                                if(email.length < 2){
                                    validation = false;
                                    errorNotification('Az email cím túl rövid!');
                                    $('.bootbox-body').find('#field_email').addClass('error');
                                }

                                if(invoice_address.length < 6){
                                    validation = false;
                                    errorNotification('A számlázási cím túl rövid!');
                                    $('.bootbox-body').find('#field_invoice_address').addClass('error');
                                }

                                if(post_address.length < 6){
                                    validation = false;
                                    errorNotification('A levelezési cím túl rövid!');
                                    $('.bootbox-body').find('#field_post_address').addClass('error');
                                }

                                if(bank_account.length < 8){
                                    validation = false;
                                    errorNotification('A bankszámlaszám túl rövid!');
                                    $('.bootbox-body').find('#field_bank_account').addClass('error');
                                }

                                if(vat_number.length < 8){
                                    validation = false;
                                    errorNotification('Az adószám túl rövid!');
                                    $('.bootbox-body').find('#field_vat_number').addClass('error');
                                }

                                if(brand.length < 1){
                                    validation = false;
                                    errorNotification('A márka megadása kötelező!');
                                    $('.bootbox-body').find('#field_brand').addClass('error');
                                }

                                if(sub_brand.length < 1){
                                    validation = false;
                                    errorNotification('Az almárka megadása kötelező!');
                                    $('.bootbox-body').find('#field_sub_brand').addClass('error');
                                }
                                /*
                                                            if( short_code.length<1 |  short_code.length > 7 ||short_code.indexOf(' ') > 0){
                                                                validation = false;
                                                                errorNotification('Az ügyfél cégnév kód túl rövid!');
                                                                $('.bootbox-body').find('#field_short_code').addClass('error');
                                                            }
                                */
                                if(validation == true){
                                    activeInstance.$http.post(baseURL+'/admin/client/create',{
                                        name:name,
                                        email:email,
                                        invoice_address:invoice_address,
                                        post_address:post_address,
                                        bank_account:bank_account,
                                        vat_number:vat_number,
                                        brand:brand,
                                        sub_brand:sub_brand,
                                    }).then(function(response){
                                        activeInstance.list.push(response.data);
                                    });
                                }else{
                                    return false;
                                }
                            }
                        }
                    }
                }
            );



        },
        edit:function(client){
            location.href = baseURL+'/admin/client/edit/'+client.id;
        },
        destroy:function(client){
            bootbox.confirm('Biztosan el akarod távolítani ezt a céget?', function(value){
                if(value!=null){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/client/destroy',{client:client}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        successNotification('A felhasználó törölve.');
                        activeInstance.list.$remove(client);
                    });
                }
            });
        }
    }
});